import styled from 'styled-components';

const StyleWrapper = styled.div`
  .wrapper{
    position: relative;
    display: flex;
    padding: 1rem;
    align-items: center;
    gap: 0.75rem;
    align-self: stretch;
    border-radius: 0.5rem;
    background: var(--primary-light, #F8F6FF);
    img{
      height: 2.875rem;
    }
  }
`;


export default StyleWrapper;